import { NgModule } from '@angular/core';
import {TruncatePipe} from './truncate.pipe';
import {RoundNumberPipe} from './round-number.pipe';
import { DocIdConverterPipe } from './docId.pipe';
import { LocationConverterPipe } from './location.pipe';

@NgModule({
  imports: [
  ],
  declarations: [TruncatePipe, RoundNumberPipe , DocIdConverterPipe , LocationConverterPipe],
  exports: [TruncatePipe, RoundNumberPipe , DocIdConverterPipe , LocationConverterPipe]
})
export class PipeModule {
  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_pipe/pipe.module.ts